module.exports = __webpack_public_path__ + "static/img/PC-3.28c241d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/PC-3.png
// module id = J2BG
// module chunks = 0